import axios from 'axios';
import qs from 'qs';

export const getLessonsReports = (params: Record<string, any>) =>
  axios.get(`/api/v1/lesson-reports?${qs.stringify(params)}`);

export const getLessonsReportsByStudentId = ({
  studentId,
  params,
}: {
  studentId: string;
  params: Record<string, any>;
}) =>
  axios.get(
    `/api/v1/lesson-reports/students/${studentId}?${qs.stringify(params)}`,
  );
